import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=8ec5b174&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ec5b174')) {
      api.createRecord('8ec5b174', component.options)
    } else {
      api.reload('8ec5b174', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=8ec5b174&", function () {
      api.rerender('8ec5b174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lxim1T9y6JHr/JS/offershelp.vue"
export default component.exports